import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'loadingDetail': false,
  'exportingDetail': false,
  'selectedPart': null,
  'initialDate': '',
  'finalDate': '',
  'dealer': '',
  'agency': '',
  'user': '',
  'reason': '',
  'partCode': '',
  'list': [],
  'listByPage': [],
  'lostSalesDetail': [],
  'pageSize': 20,
  'pageNumber': 0,
  'downloading': false,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > pageSize * (pageNumber + 1)) {
    return [...list].slice(pageSize * pageNumber, pageSize * (pageNumber + 1));
  }
  return [...list].slice(pageNumber * pageSize);
};

export const lostSalesReportDetail = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_LOST_SALES_REPORT_DETAIL]: (state, action) => INITIAL_STATE,
    [ActionTypes.CLEAR_LOST_SALES_SELECTED_PART]: (state, action) => ({
      ...state,
      'selectedPart': null,
    }),
    [ActionTypes.UPDATE_LOST_SALES_REPORT_FILTERS]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [ActionTypes.GET_LOST_SALES_REPORT]: (state, action) => ({
      ...state,
      'loading': true,
      'selectedPart': null,
    }),
    [ActionTypes.GET_LOST_SALES_REPORT_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'listByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.GET_LOST_SALES_REPORT_ERROR]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'listByPage': [],
    }),
    [ActionTypes.CHANGE_LOST_SALES_REPORT_DETAIL_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'listByPage': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_LOST_SALES_REPORT_DETAIL_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'listByPage': [...getPage(state.list, 0, action.payload)],
    }),
    [ActionTypes.GET_PART_LOST_SALES_DETAIL_REQUEST]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.GET_PART_LOST_SALES_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'lostSalesDetail': action.response.data,
      'selectedPart': action.payload,
    }),
    [ActionTypes.GET_PART_LOST_SALES_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'lostSalesDetail': [],
      'selectedPart': '',
    }),
    [ActionTypes.GENERATE_PART_LOST_SALES_REPORT_REQUEST]: (state, action) => ({
      ...state,
      'exportingDetail': true,
    }),
    [ActionTypes.GENERATE_PART_LOST_SALES_REPORT_SUCCESS]: (state, action) => {
      downloadFile(action.response.data);
      return {...state, 'exportingDetail': false};
    },
    [ActionTypes.GENERATE_PART_LOST_SALES_REPORT_FAILED]: (state, action) => ({
      ...state,
      'exportingDetail': false,
    }),
    [ActionTypes.DOWNLOAD_LOST_SALES_REPORT_DETAIL]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOAD_LOST_SALES_REPORT_DETAIL_SUCCESS]: (state, action) => {
      downloadFile(action.response.data);
      return {
        ...state,
        'downloading': false,
      };
    },
    [ActionTypes.DOWNLOAD_LOST_SALES_REPORT_DETAIL_ERROR]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
